/** It checks if the user is authenticated, if they are,
 it renders the "component" prop. If not, it redirects
 the user to /login.
 **/
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { log } from '../utils/helpers'
import { useKeycloak } from '@react-keycloak/web'
import { LanguageConsumer } from '../context/LanguageContext'
import { FullBodyWithLogoLoader } from '../components/Loader/FullBodyWithLogoLoader'
import { AuthConsumer } from '../context/AuthContext'
import { FullBodyLoader } from '../components/Loader/FullBodyLoader'
import { NamedRoutes } from '../routes'
import { LocalStorageService } from '../Services/LocalStorageService'

const PrivateRoute = ({ component: Component, checkSubscription,checkQuota, redirectionRoute, ...rest }) => {
  const { keycloak, initialized } = useKeycloak()
  log('Access Token is set:', keycloak?.authenticated)
  return (
    <>
      {!initialized && <FullBodyWithLogoLoader loading={true}/>}
      {!!initialized &&
      <LanguageConsumer>
        {({ locale }) => (
          <Route {...rest} render={(props) => {
            if (!keycloak?.authenticated) {
              LocalStorageService.set('EInvoicingLanguageSource', 'keyClock')
              let refs = keycloak?.createAccountUrl().split('?')[1]
              let newUrl = keycloak?.createLoginUrl({ locale: locale }) + `&kc_locale=${locale}&` + refs
              window.location.href = newUrl
            }
            return (
              keycloak?.authenticated && (!!checkSubscription ?
                (<AuthConsumer>
                  {({ taxpayerSubscriptionsLoading, taxpayerSubscriptionsData }) => (
                    !!taxpayerSubscriptionsData && !!Object.keys(taxpayerSubscriptionsData).length ?
                      (!!taxpayerSubscriptionsData.hasValidSubscription && (!checkQuota || (!!checkQuota && !!taxpayerSubscriptionsData?.hasQuota))
                        ? <Component {...rest} {...props} />
                        : <Redirect to={{
                          pathname: redirectionRoute || NamedRoutes.home,
                          state: { from: props.location }
                        }}/>) :
                      (!!taxpayerSubscriptionsLoading
                        ? <FullBodyLoader loading={true}/>
                        : <Redirect to={{
                          pathname: redirectionRoute || NamedRoutes.home,
                          state: { from: props.location }
                        }}/>)
                  )}
                </AuthConsumer>) : <Component {...rest} {...props} />)
            )
          }}/>
        )}
      </LanguageConsumer>
      }
    </>

  )
}

export default PrivateRoute
